import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

import BottomNav from '@/components/BottomNav';
import Dashboard from '@/pages/Dashboard';
import TestMotori from '@/pages/TestMotori';
import TappingTest from '@/pages/TappingTest';
import TremorTest from '@/pages/TremorTest';
import StoricoClinico from '@/pages/StoricoClinico';
import GestioneFarmaci from '@/pages/GestioneFarmaci';
import AIInsights from '@/pages/AIInsights';
import ReportGiornaliero from '@/pages/ReportGiornaliero';
import Profilo from '@/pages/Profilo';
import Onboarding from '@/pages/Onboarding';

import { getPatients } from '@/utils/api';

function App() {
  const [currentPatient, setCurrentPatient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initApp = async () => {
      try {
        const response = await getPatients();
        if (response.data && response.data.length > 0) {
          setCurrentPatient(response.data[0]);
        }
      } catch (error) {
        console.error('Errore nel caricamento paziente:', error);
      } finally {
        setLoading(false);
      }
    };

    initApp();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-center"
        >
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg text-slate-700">Caricamento...</p>
        </motion.div>
      </div>
    );
  }

  if (!currentPatient) {
    return (
      <BrowserRouter>
        <Onboarding onComplete={setCurrentPatient} />
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <div className="App">
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<Dashboard patient={currentPatient} />} />
            <Route path="/test-motori" element={<TestMotori patient={currentPatient} />} />
            <Route path="/test-motori/tapping" element={<TappingTest patient={currentPatient} />} />
            <Route path="/test-motori/tremor" element={<TremorTest patient={currentPatient} />} />
            <Route path="/storico" element={<StoricoClinico patient={currentPatient} />} />
            <Route path="/farmaci" element={<GestioneFarmaci patient={currentPatient} />} />
            <Route path="/ai-insights" element={<AIInsights patient={currentPatient} />} />
            <Route path="/report" element={<ReportGiornaliero patient={currentPatient} />} />
            <Route path="/profilo" element={<Profilo patient={currentPatient} />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AnimatePresence>
        <BottomNav />
        <Toaster position="top-center" expand={true} richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
